import type { ReactNode } from 'react';

import { SpotlightActions } from '@atlaskit/spotlight/actions';

import { SpotlightBody } from '@atlaskit/spotlight/body';

import { SpotlightCard } from '@atlaskit/spotlight/card';

import { SpotlightControls } from '@atlaskit/spotlight/controls';

import { SpotlightDismissControl } from '@atlaskit/spotlight/dismiss-control';

import { SpotlightFooter } from '@atlaskit/spotlight/footer';

import { SpotlightHeader } from '@atlaskit/spotlight/header';

import { SpotlightHeadline } from '@atlaskit/spotlight/headline';

import { PopoverContent } from '@atlaskit/spotlight/popover-content';

import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';

import type { DismissEvent, Placement } from '@atlaskit/spotlight/types';

import { Text } from '@atlaskit/primitives/compiled';

type RovoOpsSpotlightCardProps = {
	title: ReactNode;
	body: ReactNode;
	buttonText: ReactNode;
	onDismiss: (event: DismissEvent) => void;
	onDone: (event: DismissEvent) => void;
	popoverPlacement?: Placement;
};

export const RovoOpsSpotlightCard = ({
	title,
	body,
	buttonText,
	onDismiss,
	onDone,
	popoverPlacement = 'left-start',
}: RovoOpsSpotlightCardProps): JSX.Element => {
	return (
		<PopoverProvider>
			<PopoverTarget>
				<div />
			</PopoverTarget>
			<PopoverContent dismiss={onDismiss} placement={popoverPlacement} isVisible>
				<SpotlightCard>
					<SpotlightHeader>
						<SpotlightHeadline>{title}</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl autoFocus={false} onClick={onDismiss} />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightBody>
						<Text>{body}</Text>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={onDone}>{buttonText}</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
